export enum SortOrder {
  ASC = "asc",
  DESC = "desc"
}

export enum SortOrderExtended {
  DESC_NULLS_LAST = "desc nulls last",
  DESC_NULLS_FIRST = "desc nulls first",
  ASC_NULLS_FIRST = "asc nulls first",
  ASC_NULLS_LAST = "asc nulls last",
  ASC_SIMILARITY = "asc similarity",
  DESC_SIMILARITY = "desc similarity"
}

export type SortOrderType = SortOrder | SortOrderExtended;
